import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_WAERMEPUMPE: LandingPageContent = {
  slug: 'photovoltaik-waermepumpe',
  lang: 'de',
  topicId: 'photovoltaik-waermepumpe',
  title: 'Photovoltaik und Wärmepumpe: Angebote unabhängig vergleichen',
  metaDescription:
    'Wärmepumpe und Solaranlage zusammen planen: kostenlos Angebote von geprüften Fachbetrieben ' +
    'vergleichen, ganz ohne Anruf-Flut - für beide Vorhaben getrennt oder gemeinsam.',
  keywords: [
    'photovoltaik wärmepumpe',
    'pv für wärmepumpe',
    'wärmepumpe photovoltaik',
    'wärmepumpe rechner photovoltaik',
    'wärmepumpe stromverbrauch',
    'photovoltaik wallbox wärmepumpe',
  ],
  eyebrow: 'Wärmepumpe + Photovoltaik',
  h1: 'Photovoltaik und Wärmepumpe: Angebote unabhängig vergleichen',
  intro:
    'Eine Wärmepumpe ist der mit Abstand größte Stromverbraucher im Haus - und eine Photovoltaikanlage ' +
    'liefert genau dafür günstigen Eigenstrom. Bei Roofora können Sie beide Vorhaben als eigene, ' +
    'anonymisierte Anfragen stellen und unabhängig voneinander Angebote von geprüften Fachbetrieben ' +
    'vergleichen - kostenlos, ohne Anruf-Flut, mit Kontaktfreigabe erst nach Ihrer Zustimmung.',
  sections: [
    { type: 'heading', text: 'Warum Photovoltaik und Wärmepumpe zusammengehören' },
    {
      type: 'paragraph',
      text:
        'Eine Wärmepumpe wandelt Strom in ein Vielfaches an Wärme um - ob dieser Strom aus dem Netz ' +
        'oder von Ihrem eigenen Dach kommt, ändert nichts an der Heizleistung, aber deutlich an den ' +
        'Kosten pro Kilowattstunde Wärme. Wird die Wärmepumpe (automatisch oder manuell) bevorzugt ' +
        'dann betrieben, wenn die PV-Anlage viel Strom liefert, steigt der Anteil des selbst erzeugten ' +
        'Stroms am Gesamtverbrauch deutlich - statt den Mittagsüberschuss für wenig Geld ins Netz ' +
        'einzuspeisen und abends teuren Netzstrom zurückzukaufen.',
    },
    { type: 'heading', text: 'Zwei getrennte Anfragen, eine gemeinsame Planung' },
    {
      type: 'list',
      items: [
        'Photovoltaik als eigene Anfrage: Komplettsystem, reine Dachmontage oder nur Elektroinstallation',
        'Wärmepumpe als eigener Auftragstyp, unabhängig davon, ob Sie bereits eine PV-Anlage haben',
        'Beide Anfragen anonymisiert - Handwerksbetriebe geben unverbindliche Festpreis-Angebote ab, ohne dass Sie Kontaktdaten preisgeben müssen',
        'Kontakt entsteht erst, wenn Sie einen einzelnen Betrieb individuell freigeben - keine Sammelfreigabe, keine Anruf-Flut',
      ],
    },
    { type: 'heading', text: 'Worauf Sie bei der Kombination achten sollten' },
    {
      type: 'list',
      items: [
        'PV-Dimensionierung am tatsächlichen Bedarf ausrichten: der Jahresstromverbrauch inklusive Wärmepumpe sollte in die Anlagengröße einfließen, nicht nur der bisherige Haushaltsverbrauch',
        'Pufferspeicher prüfen: ein ausreichend großer Pufferspeicher erlaubt es, PV-Überschuss "thermisch" zwischenzuspeichern',
        'Vorlauftemperatur beachten: Fußbodenheizung erlaubt niedrigere Vorlauftemperaturen und damit eine effizientere Wärmepumpe als klassische Heizkörper',
        'Reihenfolge planen: wird die PV-Anlage ohne Blick auf eine später geplante Wärmepumpe dimensioniert, ist sie im Nachhinein oft zu klein für den neuen Verbrauch',
      ],
    },
  ],
  faq: [
    {
      q: 'Muss ich Photovoltaik und Wärmepumpe bei Roofora zusammen anfragen?',
      a: 'Nein - beides sind eigene Auftragstypen, die Sie unabhängig voneinander stellen können. Für eine realistische Anlagengröße lohnt es sich aber, den zusätzlichen Verbrauch durch die Wärmepumpe bei der PV-Anfrage anzugeben.',
    },
    {
      q: 'Wie stark erhöht eine Wärmepumpe meinen Stromverbrauch?',
      a: 'Das hängt stark vom Gebäude, der Heizlast und der Effizienz der Wärmepumpe ab - pauschale Zahlen dazu wären nicht seriös. Handwerksbetriebe können das anhand Ihrer Angaben zur bisherigen Heizung realistisch einschätzen.',
    },
    {
      q: 'Kann ich einen Kostenrichtwert für meine PV-Anlage sehen, bevor ich anfrage?',
      a: 'Ja - im PV-Kostenrechner erhalten Sie einen Richtwert allein für die Photovoltaik-Anlage auf Basis echter Angebotsdaten. Der Rechner bildet keinen wärmepumpen-spezifischen Aufschlag ab, da dafür keine belastbare eigene Datengrundlage existiert.',
    },
    {
      q: 'Was, wenn ich nur die Wärmepumpe anfragen möchte, ohne Photovoltaik?',
      a: 'Kein Problem - der Auftragstyp Wärmepumpe ist unabhängig von einer PV-Anlage nutzbar.',
    },
  ],
  primaryCta: { label: 'Wärmepumpe-Anfrage erstellen', action: 'customer' },
  secondaryCta: { label: 'PV-Kostenrichtwert berechnen', action: 'link', href: '/pv-kostenrechner' },
  relatedLinks: [
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik und Wärmepumpe kombinieren (Ratgeber)', href: '/blog/photovoltaik-waermepumpe-kombinieren' },
  ],
}
